/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import { Button, Table, Row, Col, Upload, Modal, Checkbox } from "antd";
import { useState } from "react";
import { EditableModal } from "./Modal";
import { HiOutlineTrash } from "react-icons/hi2";
import { StyledButton } from "../../../../../../components/styled-antd";
import type { UploadProps } from "antd/es/upload/interface";
import { CreateNotification } from "../../../../../../components/notifier";
import ExcelJS from "exceljs";
import { useExcelTemplate } from "../../../../../../components/input/arrayData/hooks/useExcelTemplate";
import _ from "lodash";

export function EditableTable({
  eFields,
  title,
  eRequests,
  setERequests,
  formFileName,
  mode,
}: {
  eRequests: any;
  setERequests: any;
  eFields: any[];
  title: string;
  formFileName: string;
  mode?: string;
}) {
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [listDelete, setListDelete] = useState<number[]>([]);
  const [fileList, setFileList] = useState<any[]>([]);
  const { exportFile } = useExcelTemplate();

  const columns = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, eRequests.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (value: any, record: any, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter(
                    (value): any => value != index
                  );
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="d-flex">
            <EditableModal
              title={title}
              eRequests={eRequests}
              setERequests={setERequests}
              eFields={eFields}
              mode="edit"
              index={index}
            />

            <Button
              onClick={() => {
                if ((eRequests.length - 1) % 10 == 0) {
                  const NUM_PAGES = Math.ceil(eRequests.length / pageSize);
                  if (currentPage >= 2 && currentPage === NUM_PAGES) {
                    setCurrentPage(currentPage - 1);
                  }
                }

                setERequests((prev: any) => {
                  return prev.filter(
                    (value: any, indexValue: number) => indexValue != index
                  );
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash
                size={20}
                className="cursor-pointer"
                color="#dc2626"
              />
            </Button>
          </div>
        );
      },
      isHide: mode === "view",
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: any, index: number) => (
        <>{(currentPage - 1) * pageSize + index + 1}</>
      ),
    },
    ...eFields.map((value, index) => {
      return {
        title: value.label,
        dataIndex: value.field,
        key: value.field,
      };
    }),
  ].filter((value: any) => value.isHide != true);

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {
      if (file.name.split(".")[file.name.split(".").length - 1] != "xlsx") {
        CreateNotification({
          title: "Import file thất bại",
          body: `File sai định dạng`,
          icon: "/icons/error.png",
        });
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push([...row.values].filter((value, index) => index != 0));
          });
        });

        data = data.filter((value, index) => index != 0);

        const dataSource: any[] = [];

        let isValid = true;
        const re = new RegExp(/^[0-9]+$/);
        const re2 = new RegExp(/^\s*-?[0-9]{1,10}\s*$/);
        let message = "";

        for (const item of data) {
          // eslint-disable-next-line no-loop-func
          eFields.forEach((value, index) => {
            if (value.field === "numLessons" || value.field === "phoneNumber") {
              if (!re.test(item[index])) {
                isValid = false;
                message = "Điện thoại hoặc số tiết phải là con số";
              }
            }
            if (value.field === "phoneNumber") {
              if (!re2.test(item[index])) {
                isValid = false;
                message = "Số điện thoại tối đa 10 chữ số";
              }
            }
          });
        }

        if (!isValid) {
          CreateNotification({
            title: "Import file thất bại",
            body: message,
            icon: "/icons/error.png",
          });

          return;
        }

        for (const item of data) {
          const record: any = {};
          eFields.forEach((value, index) => {
            if (value.field === "email") {
              record[value.field] = item[index]?.text || item[index];
            } else {
              record[value.field] = item[index];
            }
          });

          dataSource.push(record);
        }

        setERequests((prev: any) => [...prev, ...dataSource]);

        setFileList([...fileList, file]);
      };

      return false;
    },
    fileList,
    showUploadList: false,
    accept: ".xlsx",
  };

  const confirmDelete = () => {
    const NUM_PAGES = Math.ceil(eRequests.length / pageSize);
    if ((eRequests.length - listDelete.length) % 10 == 0) {
      if (currentPage >= 2 && currentPage === NUM_PAGES)
        setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...eRequests];
    newDataSource = newDataSource.filter(
      (value, index) => !listDelete.includes(index)
    );
    setERequests(newDataSource);
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const downLoad = async () => {
    const template = {
      fields: eFields.map((value) => value.field),
      sheet: "sheet1",
      fileName: formFileName,
      structures: eFields.map((value) => {
        return {
          header: value.label,
          validate: (cell: any) => {
            return true;
          },
        };
      }),
    };
    //@ts-ignore
    await exportFile(template);
  };

  return (
    <>
      {mode != "view" && (
        <Row>
          <Col>
            <EditableModal
              title={title}
              eRequests={eRequests}
              setERequests={setERequests}
              eFields={eFields}
              mode="create"
            />
          </Col>
          <>
            <Col>
              {!isMultiDelete && (
                <Button
                  className="ml-3"
                  type="primary"
                  danger
                  onClick={() => setIsMultiDelete(true)}
                >
                  Chọn nhiều để xóa
                </Button>
              )}

              {isMultiDelete && (
                <StyledButton
                  className="ml-3"
                  bgColor="green"
                  onClick={() => {
                    setIsMultiDelete(false);
                    setListDelete([]);
                  }}
                >
                  Quay lại
                </StyledButton>
              )}

              {listDelete.length != 0 && (
                <Button
                  className="ml-3"
                  type="primary"
                  onClick={showDeleteConfirm}
                  danger
                >
                  Xóa dữ liệu đã chọn
                </Button>
              )}
            </Col>

            <Col>
              <Upload {...props}>
                <StyledButton bgColor="blue" className="mx-3">
                  Tải biểu mẫu{" "}
                </StyledButton>
              </Upload>
            </Col>

            <Col>
              <div className="mt-1">
                <a href="#" className="text-primary" onClick={downLoad}>
                  Download biểu mẫu tại đây
                </a>
              </div>
            </Col>
          </>
        </Row>
      )}

      <Table
        columns={columns}
        dataSource={eRequests}
        pagination={{
          onChange: (page) => {
            setCurrentPage(page);
          },
          current: currentPage,
        }}
        scroll={{
          x: "100vh",
        }}
      />
    </>
  );
}
